import { defineComponent as s, createElementBlock as m, openBlock as d, createVNode as n, unref as e } from "vue";
import { RevButtonIcon as a } from "@ds/components/ButtonIcon";
import f from "../../../icons/generated/IconChevronLeft.vue2.js";
import p from "../../../icons/generated/IconChevronRight.vue2.js";
import { useI18n as u } from "@ds/plugin";
import i from "../../../translations/generic.translations.js";
const v = { class: "hidden gap-12 md:flex" }, N = /* @__PURE__ */ s({
  __name: "CardCarouselController",
  props: {
    prevAlternativeText: {},
    nextAlternativeText: {},
    canScrollPrev: { type: Boolean, default: !1 },
    canScrollNext: { type: Boolean, default: !1 }
  },
  emits: ["scroll"],
  setup(r, { emit: c }) {
    const o = c, l = u();
    return (x, t) => (d(), m("div", v, [
      n(e(a), {
        "alternative-text": e(l)(e(i).cardCarouselControllerPrevious),
        disabled: !r.canScrollPrev,
        icon: e(f),
        variant: "primary",
        onClick: t[0] || (t[0] = () => o("scroll", "backward"))
      }, null, 8, ["alternative-text", "disabled", "icon"]),
      n(e(a), {
        "alternative-text": e(l)(e(i).cardCarouselControllerNext),
        disabled: !r.canScrollNext,
        icon: e(p),
        variant: "primary",
        onClick: t[1] || (t[1] = () => o("scroll", "forward"))
      }, null, 8, ["alternative-text", "disabled", "icon"])
    ]));
  }
});
export {
  N as default
};
